module.exports = __webpack_public_path__ + "static/media/PREF_VDM.ea4aa2e3.png";